// Call Tracking for Ad Performance
// Tracks phone calls made from ads to measure offline conversions

/**
 * Get call source based on UTM parameters
 * Helps identify which ad/campaign drove the call
 */
export const getCallSource = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source') || 'direct',
    utm_medium: params.get('utm_medium') || 'phone',
    utm_campaign: params.get('utm_campaign') || 'unknown',
    referrer: document.referrer
  };
};

/**
 * Track phone call for Google Ads
 * Call this when user clicks phone number
 */
export const trackPhoneClick = () => {
  const source = getCallSource();

  console.log('📞 Phone click tracked:', source);

  // Google Ads conversion (if configured)
  if (window.gtag) {
    window.gtag('event', 'phone_call', {
      phone_conversion_number: '01482205358',
      source: source.utm_source,
      campaign: source.utm_campaign
    });
  }

  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: 'Phone Call',
      content_category: 'contact'
    });
  }

  // Log to analytics
  if (window.gtag) {
    window.gtag('event', 'phone_contact', {
      phone_number: '01482205358',
      source: source.utm_source,
      campaign: source.utm_campaign
    });
  }
};

/**
 * Generate dynamic phone number based on campaign
 * For advanced call tracking (CallRail, CallTracking360, etc.)
 */
export const getDynamicPhoneNumber = () => {
  const source = getCallSource();

  // Map campaigns to different phone numbers if you set them up
  const phoneNumbers = {
    google_shopping: '01482205358',
    google_search: '01482205358',
    facebook: '01482205358',
    direct: '01482205358',
    organic: '01482205358'
  };

  const key = `${source.utm_source}_${source.utm_medium}`;
  return phoneNumbers[key] || '01482205358';
};

/**
 * Track form submissions (contact forms, quote requests)
 */
export const trackFormSubmission = (formType = 'contact') => {
  const source = getCallSource();

  console.log('📝 Form submission tracked:', { formType, source });

  // Google Ads
  if (window.gtag) {
    window.gtag('event', 'generate_lead', {
      value: 0,
      currency: 'GBP',
      form_type: formType,
      source: source.utm_source
    });
  }

  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: formType,
      content_category: 'inquiry'
    });
  }
};

/**
 * Track email signup
 */
export const trackEmailSignup = () => {
  const source = getCallSource();

  console.log('📧 Email signup tracked:', source);

  // Google Ads
  if (window.gtag) {
    window.gtag('event', 'sign_up', {
      method: 'email',
      source: source.utm_source
    });
  }

  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', 'Subscribe', {
      content_name: 'Newsletter',
      content_category: 'email'
    });
  }
};
